<template>
  <div class="pt-3">
    <div class="form-section-base__controls">
      <v-row>
        <v-col>
          <v-radio-group v-model="v.role.$model" row>
            <v-radio label="Физическое лицо" :value="Role.PERSON" />
            <v-radio label="Юридическое лицо" :value="Role.ORGANIZATION" />
            <v-radio
              label="Иностранное юридическое лицо"
              :value="Role.FOREIGN_ORGANIZATION"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </div>

    <Person v-if="v.role.$model === Role.PERSON" :v="v.person" />

    <Organization
      v-if="v.role.$model === Role.ORGANIZATION"
      :v="v.organization"
    />

    <ForeignOrganization
      v-if="v.role.$model === Role.FOREIGN_ORGANIZATION"
      :v="v.foreignOrganization"
    />
  </div>
</template>

<script>
import { Role } from '@/utils/dictionaries';
import Person, { personModel, personValidation } from './Person';
import Organization, {
  organizationModel,
  getOrganizationValidation,
} from './Organization';
import ForeignOrganization, {
  foreignOrganizationModel,
  getForeignOrganizationValidation,
} from './ForeignOrganization';

export const manualModel = {
  role: Role.PERSON,
  [Role.PERSON]: personModel,
  [Role.ORGANIZATION]: organizationModel,
  [Role.FOREIGN_ORGANIZATION]: foreignOrganizationModel,
};

const getManualBaseValidation = () => ({
  role: {},
});

export const getManualValidation = (manual) => {
  if (manual.role === Role.PERSON) {
    return {
      ...getManualBaseValidation(),
      [Role.PERSON]: personValidation,
    };
  }

  if (manual.role === Role.ORGANIZATION) {
    return {
      ...getManualBaseValidation(),
      [Role.ORGANIZATION]: getOrganizationValidation(manual.organization),
    };
  }

  return {
    ...getManualBaseValidation(),
    [Role.FOREIGN_ORGANIZATION]: getForeignOrganizationValidation(
      manual.foreignOrganization
    ),
  };
};

export default {
  name: 'Manual',
  props: {
    v: {
      required: true,
    },
  },
  components: {
    Person,
    Organization,
    ForeignOrganization,
  },
  data: () => ({
    Role,
  }),
};
</script>
